<span class="notice__icon" aria-hidden="true">
  @switch (tone()) {
    @case ('error') {
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <circle cx="12" cy="12" r="9" />
        <path stroke-linecap="round" d="M12 7.5v5.25M12 16.25v.25" />
      </svg>
    }
    @case ('warning') {
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <path stroke-linejoin="round" d="M10.4 4.2a1.85 1.85 0 0 1 3.2 0l7.1 12.6a1.85 1.85 0 0 1-1.6 2.7H4.9a1.85 1.85 0 0 1-1.6-2.7Z" />
        <path stroke-linecap="round" d="M12 9.5v4M12 16.5v.25" />
      </svg>
    }
    @case ('success') {
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <circle cx="12" cy="12" r="9" />
        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 12.25 2.5 2.5 5-5.5" />
      </svg>
    }
    @default {
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
        <circle cx="12" cy="12" r="9" />
        <path stroke-linecap="round" d="M12 11v5.25M12 7.75V8" />
      </svg>
    }
  }
</span>
<div class="notice__body">
  <ng-content />
  <ng-content select=".notice-actions" />
</div>
@if (dismissible()) {
  <button type="button" class="notice__dismiss" [attr.aria-label]="dismissLabel()" (click)="dismiss.emit()">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
  </button>
}
